import * as tocbot from 'tocbot';
import BlogPost from '@type/inline/BlogPost';

declare let post: BlogPost;

window.addEventListener('DOMContentLoaded', () => {
    if (post.table_of_content) {
        const headings = Array.from(
            document.querySelectorAll('.blog-content h2, .blog-content h3')
        ) as HTMLHeadElement[];

        headings.forEach((heading, index) => {
            heading.setAttribute('id', `subheading=${index}`);
        });

        //@ts-expect-error: Init error; not real
        tocbot.init({
            tocSelector: '.toc',
            contentSelector: '.blog-content',
            headingSelector: 'h2, h3',
            headingsOffset: 200,
            scrollSmoothOffset: -200,
            hasInnerContainers: false,
            positionFixedSelector: '.toc',
            positionFixedClass: 'sticky-top',
        });
    }

    const content = document.getElementById('blog-content') as HTMLDivElement;
    const firstStickyCTAWrapper = document.getElementById('first-sticky-cta-wrapper') as HTMLDivElement;
    const secondStickyCTAWrapper = document.getElementById('second-sticky-cta-wrapper') as HTMLDivElement;
    let contentHeight;

    if (!!content && post.funnel) {
        contentHeight = content.offsetHeight;
        firstStickyCTAWrapper.style.height = `${contentHeight / 2}px`;
        secondStickyCTAWrapper.style.height = `${contentHeight / 2}px`;
    }
});
